// extracted by mini-css-extract-plugin
export var addressFields = "_g4-0";
export var animationContainer = "_g4-1";
export var footer = "_g4-2";
export var lineItems = "_g4-3";
export var modalContent = "_g4-4";
export var orderName = "_g4-5";
export var strong = "_g4-6";
export var warning = "_g4-7";